import { useState } from "react";
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";
import { useAuth } from '../../AuthContext';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';

const Item = ({ tittle, to, icon, selected, setSelected }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <MenuItem
            active={selected === tittle}
            style={{
                color: selected === tittle ? colors.blue[400] : colors.white[700],
                backgroundColor: selected === tittle 
                    ? colors.white[500] 
                    : isHovered 
                        ? colors.white[500] 
                        : 'transparent',
                transition: 'background-color 0.1s ease',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => setSelected(tittle)}
            icon={icon}
            component={<Link to={to} />}
        >
            <Typography>{tittle}</Typography>
        </MenuItem>
    );
};

const AdvertsSideBar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [selected, setSelected] = useState("Dashboard");
    const {userRole } = useAuth();

    return (
        <Box>
            <Sidebar 
                collapsed={isCollapsed}
                backgroundColor={colors.dark[800]}
                rootStyles={{
                    background: colors.dark[900],
                    height: "100vh",
                    padding: "0"
                }}
            >
                <Menu iconShape ="square">

                    <MenuItem
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
                        style={{
                            margin: "10px 0 20px 0",
                            color: colors.dark[400],
                            background: colors.dark[800]
                        }}
                    >
                        {!isCollapsed && (
                            <Box 
                                display={"flex"}
                                justifyContent={"space-between"}
                                alignContent={"center"}
                                ml={"15px"}
                            >
                                <Typography variant="h3" color={colors.primary[100]}>ADMIN</Typography>
                                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                                    <MenuOutlinedIcon />
                                </IconButton>
                            </Box>
                        )}
                    </MenuItem>
                    {userRole !== 'receptionist' && userRole !== 'user' && (
                        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                            <Item
                                tittle={"Go Back"}
                                to="/admin/dashboard"
                                icon={<ArrowBackIosOutlinedIcon/>}
                                selected={selected}
                                setSelected={setSelected}
                            />
                        </Box>
                    )}
                    {userRole !== 'receptionist' && userRole !== 'user' ? (
                        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                            <Item
                                tittle={"Dashboard"}
                                to="/admin/dashboard/website"
                                icon={<HomeOutlinedIcon/>}
                                selected={selected}
                                setSelected={setSelected}
                            />
                        </Box>
                    ):(
                        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                            <Item
                                tittle={"Dashboard"}
                                to="/user/dashboard/broadcast"
                                icon={<HomeOutlinedIcon/>}
                                selected={selected}
                                setSelected={setSelected}
                            />
                        </Box>
                    )}
                </Menu>
            </Sidebar>
        </Box>
    );
}

export default AdvertsSideBar;